import React from "react";
import {
  Box,
  Text,
  Flex,
  Image,
  Button,
  VStack,
  useColorModeValue,
  Spinner,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTenant } from "./Routers/TenantContextProvider";
import BackGroundImage from "../resources/PlatformBackround.png"

const TenantLanding: React.FC = () => {
  const { tenant, loading, error } = useTenant();
  const navigate = useNavigate();

  const overlayColor = useColorModeValue("rgba(255, 255, 255, 0.85)", "rgba(0, 0, 0, 0.65)");
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const ctaColorScheme = useColorModeValue("blue", "cyan");

  const handleEnrolClick = () => {
    navigate(`/platform/${tenant?.tenant_slug}/enrol-online`);
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error || !tenant) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Text color="red.500" fontSize="lg">
          Failed to load tenant details.
        </Text>
      </Flex>
    );
  }

  return (
    <Box
      bgImage={`url(${BackGroundImage})`}
      bgSize="cover"
      bgPosition="center"
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={4}
      pt="72px"
    >
      {/* Top Section */}
      <Box
        bg={overlayColor}
        borderRadius="lg"
        boxShadow="lg"
        mx="auto"
        my={8}
        maxW="800px"
        textAlign="center"
        px={6}
        py={10}
      >
        {/* Logo */}
      <Flex justify="center" mb={6}>
        <Image
          src={tenant.logo_url}
          alt={`${tenant.tenant_name} logo`}
          boxSize={{ base: "160px", md: "200px" }}
          objectFit="cover"
          borderRadius="full"  // ⬅️ makes it fully rounded (circular)
        />
      </Flex>

        {/* Tenant Name */}
        <Text
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          color={textColor}
          mb={2}
        >
          Welcome to {tenant.tenant_name}
        </Text>

        {/* Subheading */}
        <Text fontSize="md" color="gray.500" mb={8}>
          Empowering learning through Eduvic Learning Platform
        </Text>

        {/* CTA Button */}
        <VStack spacing={4}>
          <Button
            colorScheme={ctaColorScheme}
            size="lg"
            onClick={handleEnrolClick}
          >
            Enrol Now
          </Button>
        </VStack>
      </Box>

    {/* Footer Note */}
    <Box position="relative" bottom={0} width="100%" textAlign="center" px={4} pb={4}>
      <Text fontSize="md" color="gray.600">
        Eduvic Learning Platform – A multi-tenant learning platform with a shared assessment foundation for hybrid exams.
      </Text>
    </Box>
    </Box>
  );
};

export default TenantLanding;
